const TRAFFIC = "traffic";
const CONVERSIONS = "conversions";
const REACH = "reach";

const TRAFFIC_FIELD_TEXT = "Traffic";
const CONVERSIONS_FIELD_TEXT = "Conversions";
const REACH_FIELD_TEXT = "Reach";

module.exports = {
  TRAFFIC,
  CONVERSIONS,
  REACH,
  TRAFFIC_FIELD_TEXT,
  CONVERSIONS_FIELD_TEXT,
  REACH_FIELD_TEXT
};
